const AppConstant = {
  OrderType: {
    CONTRACT: 0,
    OPEN: 1,
    NO_FREIGHT: 2,
    MARKET: 3,
  },
  DepotGroupType: {
    ASSOCIATED_DEPOT: 'ASSOCIATED DEPOTS',
    BILL_TO_PARTY_DEPOT: 'BILL TO PARTY DEPOTS',
    OTHER_DEPOT: 'OTHER DEPOTS',
    ALL_DEPOT: 'ALL DEPOTS',
  },
};
export default AppConstant;
